import {AbstractControl} from '@angular/forms';

export class PasswordValidation {

  static MatchPassword(AC: AbstractControl) {
    let password = AC.get('password').value;
    let confirmPassword = AC.get('passwordConfirmation').value;

    if(password !== confirmPassword) {
      AC
        .get('passwordConfirmation')
        .setErrors( {MatchPassword: true} )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/utils/password-validation.util.ts